/**
 * v-image-preview directive
 *
 * Adds click-to-lightbox on images inside v-html content,
 * using Element Plus ElImageViewer (already in bundle).
 *
 * Usage:  <div v-image-preview v-html="richContent"></div>
 */

import { createApp, h, ref } from "vue";
import { ElImageViewer } from "element-plus";

function openViewer(urls, startIndex = 0) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const app = createApp({
    setup() {
      const visible = ref(true);
      return () =>
        visible.value
          ? h(ElImageViewer, {
              urlList: urls,
              initialIndex: startIndex,
              zIndex: 3000,
              onClose: () => {
                visible.value = false;
                app.unmount();
                container.remove();
              },
            })
          : null;
    },
  });
  app.mount(container);
}

function processElement(el) {
  const images = el.querySelectorAll("img:not([data-preview-bound])");
  const allSrcs = Array.from(el.querySelectorAll("img")).map((img) => img.src);

  images.forEach((img) => {
    img.dataset.previewBound = "true";
    img.style.cursor = "pointer";
    img.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const idx = allSrcs.indexOf(img.src);
      openViewer(allSrcs, idx >= 0 ? idx : 0);
    });
  });
}

export const vImagePreview = {
  mounted(el) {
    processElement(el);
  },
  updated(el) {
    requestAnimationFrame(() => processElement(el));
  },
};
